import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { AdditionalConsentSubForm } from '../subforms/AdditionalConsent';

export const BBBankStandardSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(ContactSchema(settings))
        .concat(SalaryRequestSchema)
        .concat(DocumentsSchema(settings))
);

export const BBBankStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} />
        </>
    );
}